// extracted by mini-css-extract-plugin
export default {"change":"ChangePassword_change__whHLT","info":"ChangePassword_info__eGqwB","input":"ChangePassword_input__MdenF"};